if (!customElements.get('product-inventory')) {
  class ProductInventory extends HTMLElement {
    constructor() {
      super();
      window.initLazyScript(this, this.initLazySection.bind(this));
    }

    initLazySection() {
      this.inventoryNotice = this.querySelector('.js-inventory-notice');
      this.urgencyMessage = this.querySelector('.js-inventory-urgency');
      this.indicatorBar = this.querySelector('.js-inventory-indicator');
      this.variantInventory = this.getVariantInventory();

      // Bind to on:variant:change event for this product
      const variantPicker = this.closest('.product-info')?.querySelector('variant-picker');
      if (variantPicker) {
        variantPicker.addEventListener('on:variant:change', this.handleVariantChange.bind(this));
      }

      // Init
      this.updateInventory(
        this.dataset.inventoryLevel,
        this.dataset.variantAvailable === 'true'
      );
    }

    getVariantInventory() {
      const dataEl = this.querySelector('[type="application/json"]');
      return this.variantInventory || JSON.parse(dataEl.textContent);
    }

    handleVariantChange(evt) {
      if (evt.detail.variant) {
        const inventory = this.variantInventory.filter(
          (variant) => variant.id === evt.detail.variant.id
        )[0];

        if (inventory) {
          this.updateInventory(inventory.inventory_level, inventory.available);
        } else {
          this.updateInventory('none', false);
          this.hidden = true;
        }
      } else {
        this.updateInventory('none', false);
        this.hidden = true;
      }
    }

    updateInventory(level, available) {
      let inventoryLevel = level;

      if (!inventoryLevel || inventoryLevel === '') {
        inventoryLevel = available ? 'in_stock' : 'none';
      }

      if (
        this.dataset.showNotice === 'always' ||
        (this.dataset.showNotice === 'low' && inventoryLevel.includes('low'))
      ) {
        this.hidden = false;

        // Set the inventory level data attribute
        this.setAttribute('data-inventory-level', inventoryLevel);

        // Determine which notice to show
        if (inventoryLevel.includes('low')) {
          this.inventoryNotice.innerText = theme.strings.lowStock;
        } else if (inventoryLevel === 'normal' || inventoryLevel === 'in_stock') {
          this.inventoryNotice.innerText = theme.strings.inStock;
        } else if (inventoryLevel === 'none') {
          this.inventoryNotice.innerText = theme.strings.noStock;
        }

        // Update urgency message if needed
        if (this.urgencyMessage) {
          if (inventoryLevel === 'very_low') {
            this.urgencyMessage.innerHTML = this.dataset.textVeryLow;
          } else if (inventoryLevel === 'low') {
            this.urgencyMessage.innerHTML = this.dataset.textLow;
          } else if (inventoryLevel === 'normal' || inventoryLevel === 'in_stock') {
            this.urgencyMessage.innerHTML = this.dataset.textNormal;
          } else if (inventoryLevel === 'none') {
            this.urgencyMessage.innerHTML = this.dataset.textNoStock;
          }
        }

        // Update the bar indicator with symbolic widths
        if (this.indicatorBar) {
          this.indicatorBar.hidden = false;

          let newWidth;
          switch (inventoryLevel) {
            case 'none':
              newWidth = 0;
              break;
            case 'very_low':
              newWidth = 10;
              break;
            case 'low':
              newWidth = 35;
              break;
            case 'normal':
            case 'in_stock':
            default:
              newWidth = 100;
              break;
          }

          this.indicatorBar.querySelector('span').style.width = `${newWidth}%`;
        }
      } else {
        this.hidden = true;
      }
    }
  }

  customElements.define('product-inventory', ProductInventory);
}